import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { DetectLanguageChangeComponent } from "src/app/shared/components/utility/detect-language-change/detect-language-change.component";
import { PresentationComponent } from "src/app/shared/components/presentation/presentation.component";
import { TopLogoComponent } from "src/app/shared/components/top-logo/top-logo.component";

@Component({
  selector: "app-auth-layout",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-detect-language-change></app-detect-language-change>
    <div class="container-fluid auth-layout">
      <div class="row">
        <div class="col"></div>
      </div>
      <app-top-logo class="d-block d-md-none pt-2"></app-top-logo>
      <div class="row justify-content-center login-height-md">
        <div class="col-12 col-md-6 col-lg-4 col-xl-4 d-none d-md-block p-0">
          <app-presentation></app-presentation>
        </div>
        <div class="col-12 col-md-6 col-lg-8 col-xl-8 p-4 p-sm-5 auth-layout__content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        max-width: 100%;
        overflow-x: clip;
      }

      .auth-layout,
      .auth-layout__content {
        max-width: 100%;
        min-width: 0;
        overflow-x: clip;
      }
    `,
  ],
  imports: [RouterOutlet, DetectLanguageChangeComponent, PresentationComponent, TopLogoComponent],
})
export class AuthLayoutComponent {}
